module.exports = __webpack_public_path__ + "static/media/logo.6ba11f4d.jpg";